"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledOptionWrapper = exports.StyledAttributeWrapper = exports.StyledAttributeTitle = void 0;
const ui_components_1 = require("@groupby/ui-components");
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledAttributeTitle = styled_components_1.default.div `
  margin-bottom: ${({ theme }) => theme.spacing(1)}; 
  font-weight: 600;
  font-size: 0.75rem;
`;
exports.StyledAttributeWrapper = styled_components_1.default.div `
  padding: ${({ theme }) => theme.spacing(1)};
  display: flex;
  -webkit-box-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  flex-direction: column;
`;
exports.StyledOptionWrapper = styled_components_1.default.div `
  display: flex;
  justify-content: space-between;
  width: 100%;

  svg {
    color: ${ui_components_1.baseColors.blue300};
  }
`;
